// 모집 포지션 옵션 — DB에는 value(짧은 한국어)로 저장하고 화면에는 label(풀어쓰기)로 표시
export const POSITION_OPTIONS: { value: string; label: string }[] = [
  { value: '트레이너', label: '트레이너' },
  { value: '대강', label: '대강 (대타 강사)' },
  { value: '필라테스 강사', label: '필라테스 강사' },
  { value: '기타 종목', label: '기타 종목' },
  { value: '요가 강사', label: '요가 강사' },
  { value: '아카데미 교육 강사', label: '아카데미 교육 강사' },
];

export const isKnownPosition = (v: string) => POSITION_OPTIONS.some(p => p.value === v);

// 알려진 enum이면 풀어쓰기 라벨, 자유 텍스트면 원본 그대로 (기존 데이터 호환)
export const getPositionLabel = (v: string | null | undefined): string => {
  if (!v) return '';
  return POSITION_OPTIONS.find(p => p.value === v)?.label || v;
};
